import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { BackednResponse } from "@shared/lib/types";
import { REPORTS_LIST_QUERY_KEY } from "../constants";

import { ReportService } from "../services/Report.servie";
import { IReportDetail, ReportMedia } from "@shared/lib/types/reports";

export function useGetReportMedia(
  id: string,
  mediaId: string,
  enabled = true
) {
  const { data, isFetching, isError, error, refetch } = useQuery<
    BackednResponse<ReportMedia>
  >({
    queryKey: [REPORTS_LIST_QUERY_KEY, id, mediaId],
    queryFn: () => ReportService.getReportMedia(mediaId),
    enabled: Boolean(id && mediaId && enabled),
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    reportMedia: data?.data,
    isFetching,
    isError,
    refetch,
  };
}
